import * as Types from '../../__generated__/api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { DestinationFragmentDoc } from './destination';
import { ActionFragmentDoc } from './actions';
import { LabelFragmentDoc } from './labels';
import { ButtonFragmentDoc } from './buttons';
import { CardTrackingFragmentDoc } from './tracking';
export type ProgressFragment = {
  __typename: 'Progress';
  percentage: number;
  progressPerMinute: number;
};

export type VodCardFragment = {
  __typename: 'VodCard';
  id: string;
  imageUrl: string;
  logoUrl: string | null;
  title: string | null;
  subTitle: string | null;
  mobileImageUrl: string;
  tabletImageUrl: string;
  desktopImageUrl: string;
  destination: {
    __typename: 'Destination';
    externalId: string;
    path: string;
    type: Types.DestinationType;
    icid: Types.Scalars['Map']['output'] | null;
  };
  action: {
    __typename: 'Action';
    serverAction: { __typename: 'ServerAction'; payload: string } | null;
    tracking: {
      __typename: 'Tracking';
      identifier: string;
      details: Types.Scalars['Map']['output'];
    } | null;
    clientAction:
      | {
          __typename: 'DestinationClientAction';
          destination: {
            __typename: 'Destination';
            icid: Types.Scalars['Map']['output'] | null;
            externalId: string;
            path: string;
            type: Types.DestinationType;
          };
        }
      | { __typename: 'DisplayCastMenuAction'; actionName: string }
      | { __typename: 'DisplayPageModalAction'; path: string }
      | { __typename: 'IgnoreClientAction'; actionName: string }
      | { __typename: 'OpenEntitlementClientAction'; primaryId: string }
      | { __typename: 'OpenNotificationSettingsClientAction' }
      | { __typename: 'OpenPrivacySettingsClientAction' }
      | { __typename: 'OpenTechnicalInformationClientAction' }
      | { __typename: 'PartnerLinkClientAction'; actionName: string; url: string }
      | { __typename: 'ReloadClientAction'; actionName: string }
      | { __typename: 'ShowActionsModalClientAction'; actionName: string }
      | { __typename: 'SignOutClientAction' }
      | {
          __typename: 'ToggleButtonAction';
          actionName: string;
          reloadDelayInMs: number | null;
          shouldReloadClient: boolean;
        };
  };
  labels: Array<{ __typename: 'Label'; color: string | null; text: string; textColor: string }>;
  progress: { __typename: 'Progress'; percentage: number; progressPerMinute: number } | null;
  button: {
    __typename: 'Button';
    title: string;
    dsType: Types.DsButtonType;
    iconUrl: string | null;
    activeIconUrl: string | null;
    imageUrl: string | null;
    activeImageUrl: string | null;
    isIconAnimated: boolean | null;
    backgroundColor: string | null;
    textColor: string | null;
    focusedBackgroundColor: string | null;
    focusedTextColor: string | null;
    backgroundOpacityInPct: number | null;
    focusedBackgroundOpacityInPct: number | null;
    toggleTitle: string | null;
    toggleDsType: Types.DsButtonType | null;
    toggleIconUrl: string | null;
    toggleActiveIconUrl: string | null;
    toggleImageUrl: string | null;
    toggleActiveImageUrl: string | null;
    toggleIsIconAnimated: boolean | null;
    action: {
      __typename: 'Action';
      serverAction: { __typename: 'ServerAction'; payload: string } | null;
      tracking: {
        __typename: 'Tracking';
        identifier: string;
        details: Types.Scalars['Map']['output'];
      } | null;
      clientAction:
        | {
            __typename: 'DestinationClientAction';
            destination: {
              __typename: 'Destination';
              icid: Types.Scalars['Map']['output'] | null;
              externalId: string;
              path: string;
              type: Types.DestinationType;
            };
          }
        | { __typename: 'DisplayCastMenuAction'; actionName: string }
        | { __typename: 'DisplayPageModalAction'; path: string }
        | { __typename: 'IgnoreClientAction'; actionName: string }
        | { __typename: 'OpenEntitlementClientAction'; primaryId: string }
        | { __typename: 'OpenNotificationSettingsClientAction' }
        | { __typename: 'OpenPrivacySettingsClientAction' }
        | { __typename: 'OpenTechnicalInformationClientAction' }
        | { __typename: 'PartnerLinkClientAction'; actionName: string; url: string }
        | { __typename: 'ReloadClientAction'; actionName: string }
        | { __typename: 'ShowActionsModalClientAction'; actionName: string }
        | { __typename: 'SignOutClientAction' }
        | {
            __typename: 'ToggleButtonAction';
            actionName: string;
            reloadDelayInMs: number | null;
            shouldReloadClient: boolean;
          };
    };
    toggleAction: {
      __typename: 'Action';
      serverAction: { __typename: 'ServerAction'; payload: string } | null;
      tracking: {
        __typename: 'Tracking';
        identifier: string;
        details: Types.Scalars['Map']['output'];
      } | null;
      clientAction:
        | {
            __typename: 'DestinationClientAction';
            destination: {
              __typename: 'Destination';
              icid: Types.Scalars['Map']['output'] | null;
              externalId: string;
              path: string;
              type: Types.DestinationType;
            };
          }
        | { __typename: 'DisplayCastMenuAction'; actionName: string }
        | { __typename: 'DisplayPageModalAction'; path: string }
        | { __typename: 'IgnoreClientAction'; actionName: string }
        | { __typename: 'OpenEntitlementClientAction'; primaryId: string }
        | { __typename: 'OpenNotificationSettingsClientAction' }
        | { __typename: 'OpenPrivacySettingsClientAction' }
        | { __typename: 'OpenTechnicalInformationClientAction' }
        | { __typename: 'PartnerLinkClientAction'; actionName: string; url: string }
        | { __typename: 'ReloadClientAction'; actionName: string }
        | { __typename: 'ShowActionsModalClientAction'; actionName: string }
        | { __typename: 'SignOutClientAction' }
        | {
            __typename: 'ToggleButtonAction';
            actionName: string;
            reloadDelayInMs: number | null;
            shouldReloadClient: boolean;
          };
    } | null;
    toggleToolTip: {
      __typename: 'ToolTip';
      text: string;
      textColor: string;
      backgroundColor: string;
    } | null;
  } | null;
  actionButton: {
    __typename: 'Button';
    title: string;
    dsType: Types.DsButtonType;
    iconUrl: string | null;
    activeIconUrl: string | null;
    imageUrl: string | null;
    activeImageUrl: string | null;
    isIconAnimated: boolean | null;
    backgroundColor: string | null;
    textColor: string | null;
    focusedBackgroundColor: string | null;
    focusedTextColor: string | null;
    backgroundOpacityInPct: number | null;
    focusedBackgroundOpacityInPct: number | null;
    toggleTitle: string | null;
    toggleDsType: Types.DsButtonType | null;
    toggleIconUrl: string | null;
    toggleActiveIconUrl: string | null;
    toggleImageUrl: string | null;
    toggleActiveImageUrl: string | null;
    toggleIsIconAnimated: boolean | null;
    action: {
      __typename: 'Action';
      serverAction: { __typename: 'ServerAction'; payload: string } | null;
      tracking: {
        __typename: 'Tracking';
        identifier: string;
        details: Types.Scalars['Map']['output'];
      } | null;
      clientAction:
        | {
            __typename: 'DestinationClientAction';
            destination: {
              __typename: 'Destination';
              icid: Types.Scalars['Map']['output'] | null;
              externalId: string;
              path: string;
              type: Types.DestinationType;
            };
          }
        | { __typename: 'DisplayCastMenuAction'; actionName: string }
        | { __typename: 'DisplayPageModalAction'; path: string }
        | { __typename: 'IgnoreClientAction'; actionName: string }
        | { __typename: 'OpenEntitlementClientAction'; primaryId: string }
        | { __typename: 'OpenNotificationSettingsClientAction' }
        | { __typename: 'OpenPrivacySettingsClientAction' }
        | { __typename: 'OpenTechnicalInformationClientAction' }
        | { __typename: 'PartnerLinkClientAction'; actionName: string; url: string }
        | { __typename: 'ReloadClientAction'; actionName: string }
        | { __typename: 'ShowActionsModalClientAction'; actionName: string }
        | { __typename: 'SignOutClientAction' }
        | {
            __typename: 'ToggleButtonAction';
            actionName: string;
            reloadDelayInMs: number | null;
            shouldReloadClient: boolean;
          };
    };
    toggleAction: {
      __typename: 'Action';
      serverAction: { __typename: 'ServerAction'; payload: string } | null;
      tracking: {
        __typename: 'Tracking';
        identifier: string;
        details: Types.Scalars['Map']['output'];
      } | null;
      clientAction:
        | {
            __typename: 'DestinationClientAction';
            destination: {
              __typename: 'Destination';
              icid: Types.Scalars['Map']['output'] | null;
              externalId: string;
              path: string;
              type: Types.DestinationType;
            };
          }
        | { __typename: 'DisplayCastMenuAction'; actionName: string }
        | { __typename: 'DisplayPageModalAction'; path: string }
        | { __typename: 'IgnoreClientAction'; actionName: string }
        | { __typename: 'OpenEntitlementClientAction'; primaryId: string }
        | { __typename: 'OpenNotificationSettingsClientAction' }
        | { __typename: 'OpenPrivacySettingsClientAction' }
        | { __typename: 'OpenTechnicalInformationClientAction' }
        | { __typename: 'PartnerLinkClientAction'; actionName: string; url: string }
        | { __typename: 'ReloadClientAction'; actionName: string }
        | { __typename: 'ShowActionsModalClientAction'; actionName: string }
        | { __typename: 'SignOutClientAction' }
        | {
            __typename: 'ToggleButtonAction';
            actionName: string;
            reloadDelayInMs: number | null;
            shouldReloadClient: boolean;
          };
    } | null;
    toggleToolTip: {
      __typename: 'ToolTip';
      text: string;
      textColor: string;
      backgroundColor: string;
    } | null;
  } | null;
  actions: Array<{
    __typename: 'CardAction';
    title: string | null;
    icon: string | null;
    action: {
      __typename: 'Action';
      serverAction: { __typename: 'ServerAction'; payload: string } | null;
      tracking: {
        __typename: 'Tracking';
        identifier: string;
        details: Types.Scalars['Map']['output'];
      } | null;
      clientAction:
        | {
            __typename: 'DestinationClientAction';
            destination: {
              __typename: 'Destination';
              icid: Types.Scalars['Map']['output'] | null;
              externalId: string;
              path: string;
              type: Types.DestinationType;
            };
          }
        | { __typename: 'DisplayCastMenuAction'; actionName: string }
        | { __typename: 'DisplayPageModalAction'; path: string }
        | { __typename: 'IgnoreClientAction'; actionName: string }
        | { __typename: 'OpenEntitlementClientAction'; primaryId: string }
        | { __typename: 'OpenNotificationSettingsClientAction' }
        | { __typename: 'OpenPrivacySettingsClientAction' }
        | { __typename: 'OpenTechnicalInformationClientAction' }
        | { __typename: 'PartnerLinkClientAction'; actionName: string; url: string }
        | { __typename: 'ReloadClientAction'; actionName: string }
        | { __typename: 'ShowActionsModalClientAction'; actionName: string }
        | { __typename: 'SignOutClientAction' }
        | {
            __typename: 'ToggleButtonAction';
            actionName: string;
            reloadDelayInMs: number | null;
            shouldReloadClient: boolean;
          };
    };
  }>;
  tracking: {
    __typename: 'CardTracking';
    legacy: {
      __typename: 'LegacyCardTracking';
      presentationTitle: string | null;
      teaserType: string | null;
      woid: string | null;
    } | null;
  } | null;
};

export type CollectionCardFragment = {
  __typename: 'CollectionCard';
  id: string;
  classification: Types.CardClassification;
  title: string | null;
  image: { __typename: 'CollectionCardImage'; url: string; activeUrl: string; isAnimated: boolean };
  background: {
    __typename: 'CardBackground';
    activeGradientColor: string | null;
    backgroundColor: string;
    gradientColor: string | null;
    imageUrl: string | null;
    mobileImageUrl: string | null;
    tabletImageUrl: string | null;
    desktopImageUrl: string | null;
  };
  destination: {
    __typename: 'Destination';
    externalId: string;
    path: string;
    type: Types.DestinationType;
    icid: Types.Scalars['Map']['output'] | null;
  };
  tracking: {
    __typename: 'CardTracking';
    legacy: {
      __typename: 'LegacyCardTracking';
      presentationTitle: string | null;
      teaserType: string | null;
      woid: string | null;
    } | null;
  } | null;
};

export type LiveCardFragment = {
  __typename: 'LiveCard';
  id: string;
  imageUrl: string;
  title: string | null;
  subTitle: string | null;
  subTitleIcon: string | null;
  secondaryText: string | null;
  broadcastLogoUrl: string | null;
  logoUrl: string | null;
  nextProgramTitle: string | null;
  nextProgramImageUrl: string | null;
  nextProgramStart: number | null;
  mobileImageUrl: string;
  tabletImageUrl: string;
  desktopImageUrl: string;
  mobileNextProgramImageUrl: string | null;
  tabletNextProgramImageUrl: string | null;
  desktopNextProgramImageUrl: string | null;
  labels: Array<{ __typename: 'Label'; text: string; color: string | null; textColor: string }>;
  destination: {
    __typename: 'Destination';
    externalId: string;
    path: string;
    type: Types.DestinationType;
    icid: Types.Scalars['Map']['output'] | null;
  };
  action: {
    __typename: 'Action';
    serverAction: { __typename: 'ServerAction'; payload: string } | null;
    tracking: {
      __typename: 'Tracking';
      identifier: string;
      details: Types.Scalars['Map']['output'];
    } | null;
    clientAction:
      | {
          __typename: 'DestinationClientAction';
          destination: {
            __typename: 'Destination';
            icid: Types.Scalars['Map']['output'] | null;
            externalId: string;
            path: string;
            type: Types.DestinationType;
          };
        }
      | { __typename: 'DisplayCastMenuAction'; actionName: string }
      | { __typename: 'DisplayPageModalAction'; path: string }
      | { __typename: 'IgnoreClientAction'; actionName: string }
      | { __typename: 'OpenEntitlementClientAction'; primaryId: string }
      | { __typename: 'OpenNotificationSettingsClientAction' }
      | { __typename: 'OpenPrivacySettingsClientAction' }
      | { __typename: 'OpenTechnicalInformationClientAction' }
      | { __typename: 'PartnerLinkClientAction'; actionName: string; url: string }
      | { __typename: 'ReloadClientAction'; actionName: string }
      | { __typename: 'ShowActionsModalClientAction'; actionName: string }
      | { __typename: 'SignOutClientAction' }
      | {
          __typename: 'ToggleButtonAction';
          actionName: string;
          reloadDelayInMs: number | null;
          shouldReloadClient: boolean;
        };
  };
  progress: { __typename: 'Progress'; percentage: number; progressPerMinute: number } | null;
  button: {
    __typename: 'Button';
    title: string;
    dsType: Types.DsButtonType;
    iconUrl: string | null;
    activeIconUrl: string | null;
    imageUrl: string | null;
    activeImageUrl: string | null;
    isIconAnimated: boolean | null;
    backgroundColor: string | null;
    textColor: string | null;
    focusedBackgroundColor: string | null;
    focusedTextColor: string | null;
    backgroundOpacityInPct: number | null;
    focusedBackgroundOpacityInPct: number | null;
    toggleTitle: string | null;
    toggleDsType: Types.DsButtonType | null;
    toggleIconUrl: string | null;
    toggleActiveIconUrl: string | null;
    toggleImageUrl: string | null;
    toggleActiveImageUrl: string | null;
    toggleIsIconAnimated: boolean | null;
    action: {
      __typename: 'Action';
      serverAction: { __typename: 'ServerAction'; payload: string } | null;
      tracking: {
        __typename: 'Tracking';
        identifier: string;
        details: Types.Scalars['Map']['output'];
      } | null;
      clientAction:
        | {
            __typename: 'DestinationClientAction';
            destination: {
              __typename: 'Destination';
              icid: Types.Scalars['Map']['output'] | null;
              externalId: string;
              path: string;
              type: Types.DestinationType;
            };
          }
        | { __typename: 'DisplayCastMenuAction'; actionName: string }
        | { __typename: 'DisplayPageModalAction'; path: string }
        | { __typename: 'IgnoreClientAction'; actionName: string }
        | { __typename: 'OpenEntitlementClientAction'; primaryId: string }
        | { __typename: 'OpenNotificationSettingsClientAction' }
        | { __typename: 'OpenPrivacySettingsClientAction' }
        | { __typename: 'OpenTechnicalInformationClientAction' }
        | { __typename: 'PartnerLinkClientAction'; actionName: string; url: string }
        | { __typename: 'ReloadClientAction'; actionName: string }
        | { __typename: 'ShowActionsModalClientAction'; actionName: string }
        | { __typename: 'SignOutClientAction' }
        | {
            __typename: 'ToggleButtonAction';
            actionName: string;
            reloadDelayInMs: number | null;
            shouldReloadClient: boolean;
          };
    };
    toggleAction: {
      __typename: 'Action';
      serverAction: { __typename: 'ServerAction'; payload: string } | null;
      tracking: {
        __typename: 'Tracking';
        identifier: string;
        details: Types.Scalars['Map']['output'];
      } | null;
      clientAction:
        | {
            __typename: 'DestinationClientAction';
            destination: {
              __typename: 'Destination';
              icid: Types.Scalars['Map']['output'] | null;
              externalId: string;
              path: string;
              type: Types.DestinationType;
            };
          }
        | { __typename: 'DisplayCastMenuAction'; actionName: string }
        | { __typename: 'DisplayPageModalAction'; path: string }
        | { __typename: 'IgnoreClientAction'; actionName: string }
        | { __typename: 'OpenEntitlementClientAction'; primaryId: string }
        | { __typename: 'OpenNotificationSettingsClientAction' }
        | { __typename: 'OpenPrivacySettingsClientAction' }
        | { __typename: 'OpenTechnicalInformationClientAction' }
        | { __typename: 'PartnerLinkClientAction'; actionName: string; url: string }
        | { __typename: 'ReloadClientAction'; actionName: string }
        | { __typename: 'ShowActionsModalClientAction'; actionName: string }
        | { __typename: 'SignOutClientAction' }
        | {
            __typename: 'ToggleButtonAction';
            actionName: string;
            reloadDelayInMs: number | null;
            shouldReloadClient: boolean;
          };
    } | null;
    toggleToolTip: {
      __typename: 'ToolTip';
      text: string;
      textColor: string;
      backgroundColor: string;
    } | null;
  } | null;
  nextProgramLabels: Array<{
    __typename: 'Label';
    color: string | null;
    text: string;
    textColor: string;
  }> | null;
  nextProgramButton: {
    __typename: 'Button';
    title: string;
    dsType: Types.DsButtonType;
    iconUrl: string | null;
    activeIconUrl: string | null;
    imageUrl: string | null;
    activeImageUrl: string | null;
    isIconAnimated: boolean | null;
    backgroundColor: string | null;
    textColor: string | null;
    focusedBackgroundColor: string | null;
    focusedTextColor: string | null;
    backgroundOpacityInPct: number | null;
    focusedBackgroundOpacityInPct: number | null;
    toggleTitle: string | null;
    toggleDsType: Types.DsButtonType | null;
    toggleIconUrl: string | null;
    toggleActiveIconUrl: string | null;
    toggleImageUrl: string | null;
    toggleActiveImageUrl: string | null;
    toggleIsIconAnimated: boolean | null;
    action: {
      __typename: 'Action';
      serverAction: { __typename: 'ServerAction'; payload: string } | null;
      tracking: {
        __typename: 'Tracking';
        identifier: string;
        details: Types.Scalars['Map']['output'];
      } | null;
      clientAction:
        | {
            __typename: 'DestinationClientAction';
            destination: {
              __typename: 'Destination';
              icid: Types.Scalars['Map']['output'] | null;
              externalId: string;
              path: string;
              type: Types.DestinationType;
            };
          }
        | { __typename: 'DisplayCastMenuAction'; actionName: string }
        | { __typename: 'DisplayPageModalAction'; path: string }
        | { __typename: 'IgnoreClientAction'; actionName: string }
        | { __typename: 'OpenEntitlementClientAction'; primaryId: string }
        | { __typename: 'OpenNotificationSettingsClientAction' }
        | { __typename: 'OpenPrivacySettingsClientAction' }
        | { __typename: 'OpenTechnicalInformationClientAction' }
        | { __typename: 'PartnerLinkClientAction'; actionName: string; url: string }
        | { __typename: 'ReloadClientAction'; actionName: string }
        | { __typename: 'ShowActionsModalClientAction'; actionName: string }
        | { __typename: 'SignOutClientAction' }
        | {
            __typename: 'ToggleButtonAction';
            actionName: string;
            reloadDelayInMs: number | null;
            shouldReloadClient: boolean;
          };
    };
    toggleAction: {
      __typename: 'Action';
      serverAction: { __typename: 'ServerAction'; payload: string } | null;
      tracking: {
        __typename: 'Tracking';
        identifier: string;
        details: Types.Scalars['Map']['output'];
      } | null;
      clientAction:
        | {
            __typename: 'DestinationClientAction';
            destination: {
              __typename: 'Destination';
              icid: Types.Scalars['Map']['output'] | null;
              externalId: string;
              path: string;
              type: Types.DestinationType;
            };
          }
        | { __typename: 'DisplayCastMenuAction'; actionName: string }
        | { __typename: 'DisplayPageModalAction'; path: string }
        | { __typename: 'IgnoreClientAction'; actionName: string }
        | { __typename: 'OpenEntitlementClientAction'; primaryId: string }
        | { __typename: 'OpenNotificationSettingsClientAction' }
        | { __typename: 'OpenPrivacySettingsClientAction' }
        | { __typename: 'OpenTechnicalInformationClientAction' }
        | { __typename: 'PartnerLinkClientAction'; actionName: string; url: string }
        | { __typename: 'ReloadClientAction'; actionName: string }
        | { __typename: 'ShowActionsModalClientAction'; actionName: string }
        | { __typename: 'SignOutClientAction' }
        | {
            __typename: 'ToggleButtonAction';
            actionName: string;
            reloadDelayInMs: number | null;
            shouldReloadClient: boolean;
          };
    } | null;
    toggleToolTip: {
      __typename: 'ToolTip';
      text: string;
      textColor: string;
      backgroundColor: string;
    } | null;
  } | null;
  tracking: {
    __typename: 'CardTracking';
    legacy: {
      __typename: 'LegacyCardTracking';
      presentationTitle: string | null;
      teaserType: string | null;
      woid: string | null;
    } | null;
  } | null;
};

export type ContentCardFragment = {
  __typename: 'ContentCard';
  id: string;
  title: string | null;
  logoUrl: string | null;
  imageUrl: string;
  subTitle: string | null;
  countdownTo: number | null;
  mobileImageUrl: string;
  tabletImageUrl: string;
  desktopImageUrl: string;
  destination: {
    __typename: 'Destination';
    externalId: string;
    path: string;
    type: Types.DestinationType;
    icid: Types.Scalars['Map']['output'] | null;
  };
  action: {
    __typename: 'Action';
    serverAction: { __typename: 'ServerAction'; payload: string } | null;
    tracking: {
      __typename: 'Tracking';
      identifier: string;
      details: Types.Scalars['Map']['output'];
    } | null;
    clientAction:
      | {
          __typename: 'DestinationClientAction';
          destination: {
            __typename: 'Destination';
            icid: Types.Scalars['Map']['output'] | null;
            externalId: string;
            path: string;
            type: Types.DestinationType;
          };
        }
      | { __typename: 'DisplayCastMenuAction'; actionName: string }
      | { __typename: 'DisplayPageModalAction'; path: string }
      | { __typename: 'IgnoreClientAction'; actionName: string }
      | { __typename: 'OpenEntitlementClientAction'; primaryId: string }
      | { __typename: 'OpenNotificationSettingsClientAction' }
      | { __typename: 'OpenPrivacySettingsClientAction' }
      | { __typename: 'OpenTechnicalInformationClientAction' }
      | { __typename: 'PartnerLinkClientAction'; actionName: string; url: string }
      | { __typename: 'ReloadClientAction'; actionName: string }
      | { __typename: 'ShowActionsModalClientAction'; actionName: string }
      | { __typename: 'SignOutClientAction' }
      | {
          __typename: 'ToggleButtonAction';
          actionName: string;
          reloadDelayInMs: number | null;
          shouldReloadClient: boolean;
        };
  };
  labels: Array<{ __typename: 'Label'; color: string | null; text: string; textColor: string }>;
  tracking: {
    __typename: 'CardTracking';
    legacy: {
      __typename: 'LegacyCardTracking';
      presentationTitle: string | null;
      teaserType: string | null;
      woid: string | null;
    } | null;
  } | null;
};

export const ProgressFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProgressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Progress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progressPerMinute' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProgressFragment, unknown>;
export const VodCardFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VodCardFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VodCard' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mobileImageUrl' },
            name: { kind: 'Name', value: 'imageUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'device' },
                value: { kind: 'EnumValue', value: 'MOBILE' },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'tabletImageUrl' },
            name: { kind: 'Name', value: 'imageUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'device' },
                value: { kind: 'EnumValue', value: 'TABLET' },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'desktopImageUrl' },
            name: { kind: 'Name', value: 'imageUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'device' },
                value: { kind: 'EnumValue', value: 'DESKTOP' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DestinationFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'labels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LabelFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'button' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ButtonFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actionButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ButtonFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'action' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActionFragment' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CardTrackingFragment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VodCardFragment, unknown>;
export const CollectionCardFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CollectionCardFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CollectionCard' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'classification' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAnimated' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'background' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'activeGradientColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gradientColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'mobileImageUrl' },
                  name: { kind: 'Name', value: 'imageUrl' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'device' },
                      value: { kind: 'EnumValue', value: 'MOBILE' },
                    },
                  ],
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'tabletImageUrl' },
                  name: { kind: 'Name', value: 'imageUrl' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'device' },
                      value: { kind: 'EnumValue', value: 'TABLET' },
                    },
                  ],
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'desktopImageUrl' },
                  name: { kind: 'Name', value: 'imageUrl' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'device' },
                      value: { kind: 'EnumValue', value: 'DESKTOP' },
                    },
                  ],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DestinationFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CardTrackingFragment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CollectionCardFragment, unknown>;
export const LiveCardFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LiveCardFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LiveCard' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'labels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mobileImageUrl' },
            name: { kind: 'Name', value: 'imageUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'device' },
                value: { kind: 'EnumValue', value: 'MOBILE' },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'tabletImageUrl' },
            name: { kind: 'Name', value: 'imageUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'device' },
                value: { kind: 'EnumValue', value: 'TABLET' },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'desktopImageUrl' },
            name: { kind: 'Name', value: 'imageUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'device' },
                value: { kind: 'EnumValue', value: 'DESKTOP' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subTitleIcon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondaryText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'broadcastLogoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DestinationFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'labels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LabelFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'button' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ButtonFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextProgramTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextProgramImageUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mobileNextProgramImageUrl' },
            name: { kind: 'Name', value: 'nextProgramImageUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'device' },
                value: { kind: 'EnumValue', value: 'MOBILE' },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'tabletNextProgramImageUrl' },
            name: { kind: 'Name', value: 'nextProgramImageUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'device' },
                value: { kind: 'EnumValue', value: 'TABLET' },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'desktopNextProgramImageUrl' },
            name: { kind: 'Name', value: 'nextProgramImageUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'device' },
                value: { kind: 'EnumValue', value: 'DESKTOP' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextProgramStart' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextProgramLabels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LabelFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextProgramButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ButtonFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CardTrackingFragment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LiveCardFragment, unknown>;
export const ContentCardFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentCardFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentCard' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mobileImageUrl' },
            name: { kind: 'Name', value: 'imageUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'device' },
                value: { kind: 'EnumValue', value: 'MOBILE' },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'tabletImageUrl' },
            name: { kind: 'Name', value: 'imageUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'device' },
                value: { kind: 'EnumValue', value: 'TABLET' },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'desktopImageUrl' },
            name: { kind: 'Name', value: 'imageUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'device' },
                value: { kind: 'EnumValue', value: 'DESKTOP' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countdownTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DestinationFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'labels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LabelFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CardTrackingFragment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentCardFragment, unknown>;
